import { __decorate, __param } from 'tslib';
import { InjectionToken, ElementRef, Inject, HostBinding, Component, ChangeDetectionStrategy, ɵɵdefineInjectable, ɵɵinject, Injectable, Directive, NgModule } from '@angular/core';
import { typedFromEvent, isCurrentTarget, containsOrAfter, TuiDestroyService, TUI_IS_MOBILE, AbstractTuiDialogService, AbstractTuiDialogDirective, TuiPreventDefaultModule, TUI_DIALOGS } from '@taiga-ui/cdk';
import { tuiSlideInTop, tuiFadeIn } from '@taiga-ui/core/animations';
import { TUI_ANIMATIONS_DURATION, TUI_CLOSE_WORD } from '@taiga-ui/core/tokens';
import { POLYMORPHEUS_CONTEXT, PolymorpheusComponent, PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import { EMPTY, merge, Observable } from 'rxjs';
import { DOCUMENT, CommonModule } from '@angular/common';
import { WINDOW } from '@ng-web-apis/common';
import { filter, switchMapTo, take, takeUntil } from 'rxjs/operators';
import { TuiIdService } from '@taiga-ui/cdk/services';
import { TuiButtonModule } from '@taiga-ui/core/components/button';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@tinkoff/ng-polymorpheus';
import * as ɵngcc3 from '@taiga-ui/core/components/button';
import * as ɵngcc4 from '@taiga-ui/cdk';
import * as ɵngcc5 from 'rxjs';

function TuiDialogComponent_header_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "header", 5);
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("content", ctx_r0.header)("context", ctx_r0.context);
} }
function TuiDialogComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelementStart(2, "button", 7);
    ɵngcc0.ɵɵlistener("click", function TuiDialogComponent_ng_template_4_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.context.$implicit.complete(); });
    ɵngcc0.ɵɵtext(3, " OK ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const text_r3 = ctx.$implicit;
    ɵngcc0.ɵɵtextInterpolate1(" ", text_r3, " ");
} }
function TuiDialogComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "button", 9);
    ɵngcc0.ɵɵlistener("click", function TuiDialogComponent_div_5_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.close(); });
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 1, ctx_r2.closeWord$));
} }
const TUI_DIALOGS_CLOSE = new InjectionToken('A stream to close dialogs', {
    factory: () => EMPTY,
});
const SCROLLBAR_PLACEHOLDER = 17;
function dialogCloseStreamFactory(documentRef, windowRef, { nativeElement }, close$, destroy$, { dismissible }) {
    return dismissible
        ? merge(typedFromEvent(nativeElement, 'click').pipe(filter(isCurrentTarget)), typedFromEvent(documentRef, 'keydown').pipe(
        // TODO: iframe warning
        filter(({ key, target }) => key === 'Escape' &&
            target instanceof Element &&
            (!containsOrAfter(nativeElement, target) ||
                nativeElement.contains(target)))), typedFromEvent(documentRef, 'mousedown').pipe(
        // TODO: iframe warning
        filter(({ target, clientX }) => target instanceof Element &&
            windowRef.innerWidth - clientX > SCROLLBAR_PLACEHOLDER &&
            !containsOrAfter(nativeElement, target)), switchMapTo(typedFromEvent(documentRef, 'mouseup').pipe(take(1), 
        // TODO: iframe warning
        filter(({ target }) => target instanceof Element &&
            !containsOrAfter(nativeElement, target))))), close$).pipe(takeUntil(destroy$))
        : close$;
}
const TUI_DIALOG_CLOSE_STREAM = new InjectionToken('Dialogs closing stream');
const TUI_DIALOG_PROVIDERS = [
    TuiDestroyService,
    {
        provide: TUI_DIALOG_CLOSE_STREAM,
        deps: [
            DOCUMENT,
            WINDOW,
            ElementRef,
            TUI_DIALOGS_CLOSE,
            TuiDestroyService,
            POLYMORPHEUS_CONTEXT,
        ],
        useFactory: dialogCloseStreamFactory,
    },
];

const REQUIRED_ERROR = new Error('Required dialog was dismissed');
// @dynamic
let TuiDialogComponent = class TuiDialogComponent {
    constructor(duration, isMobile, context, close$, closeWord$) {
        this.duration = duration;
        this.isMobile = isMobile;
        this.context = context;
        this.closeWord$ = closeWord$;
        this.animation = {
            value: '',
            params: {
                start: '40px',
                duration: this.duration,
            },
        };
        this.fullscreenAnimation = {
            value: '',
            params: {
                start: '100vh',
                duration: this.duration,
            },
        };
        close$.subscribe(() => {
            this.close();
        });
    }
    get size() {
        return this.context.size;
    }
    get header() {
        return this.context.header;
    }
    get slideInTop() {
        return this.size === 'fullscreen' || this.size === 'page' || this.isMobile
            ? this.fullscreenAnimation
            : this.animation;
    }
    close() {
        if (this.context.required) {
            this.context.$implicit.error(REQUIRED_ERROR);
        }
        else {
            this.context.$implicit.complete();
        }
    }
};
TuiDialogComponent.ɵfac = function TuiDialogComponent_Factory(t) { return new (t || TuiDialogComponent)(ɵngcc0.ɵɵdirectiveInject(TUI_ANIMATIONS_DURATION), ɵngcc0.ɵɵdirectiveInject(TUI_IS_MOBILE), ɵngcc0.ɵɵdirectiveInject(POLYMORPHEUS_CONTEXT), ɵngcc0.ɵɵdirectiveInject(TUI_DIALOG_CLOSE_STREAM), ɵngcc0.ɵɵdirectiveInject(TUI_CLOSE_WORD)); };
TuiDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiDialogComponent, selectors: [["tui-dialog"]], hostVars: 5, hostBindings: function TuiDialogComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("data-size", ctx.size);
        ɵngcc0.ɵɵsyntheticHostProperty("@tuiSlideInTop", ctx.slideInTop)("@tuiFadeIn", ctx.slideInTop);
        ɵngcc0.ɵɵclassProp("_centered", ctx.header);
    } }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_DIALOG_PROVIDERS)], decls: 6, vars: 6, consts: [["polymorpheus-outlet", "", "class", "t-header", 3, "content", "context", 4, "ngIf"], [1, "t-content"], [1, "t-heading", 3, "id", "textContent"], ["polymorpheus-outlet", "", 3, "context", "content"], ["class", "t-wrapper", 4, "ngIf"], ["polymorpheus-outlet", "", 1, "t-header", 3, "content", "context"], [1, "t-buttons"], ["tuiButton", "", "size", "m", 3, "click"], [1, "t-wrapper"], ["tuiIconButton", "", "tuiPreventDefault", "mousedown", "automation-id", "tui-dialog__close", "size", "s", "appearance", "", "icon", "tuiIconCloseLarge", "shape", "rounded", 1, "t-close", 3, "title", "click"]], template: function TuiDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TuiDialogComponent_header_0_Template, 1, 2, "header", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "h2", 2);
        ɵngcc0.ɵɵelementStart(3, "section", 3);
        ɵngcc0.ɵɵtemplate(4, TuiDialogComponent_ng_template_4_Template, 4, 1, "ng-template");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, TuiDialogComponent_div_5_Template, 3, 3, "div", 4);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.header);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.context.id)("textContent", ctx.context.label);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("context", ctx.context)("content", ctx.context.content);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.context.closeable);
    } }, directives: [ɵngcc1.NgIf, ɵngcc2.PolymorpheusOutletComponent, ɵngcc3.TuiButtonComponent, ɵngcc4.TuiPreventDefaultDirective], pipes: [ɵngcc1.AsyncPipe], styles: ["[_nghost-%COMP%]{position:relative;display:flex;font:var(--tui-font-text-m);flex-direction:column;box-sizing:border-box;margin:auto;border-radius:1rem;border:40px solid transparent}[_nghost-%COMP%]:after{position:absolute;top:0;left:0;width:100%;height:100%;box-shadow:0 1.125rem 1.875rem rgba(0,0,0,.48);content:'';border-radius:inherit;pointer-events:none}[data-size='s'][_nghost-%COMP%]{width:30rem}[data-size='s'][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:1.5rem}[data-size='s'][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{margin-bottom:.5rem;font:var(--tui-font-heading-5)}[data-size='m'][_nghost-%COMP%]{width:42.5rem}[data-size='m'][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{margin-bottom:.75rem;font:var(--tui-font-heading-4)}[data-size='l'][_nghost-%COMP%]{width:55rem}[data-size='l'][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{margin-bottom:1rem}[data-size=fullscreen][_nghost-%COMP%], [data-size=page][_nghost-%COMP%]{width:100vw;min-height:100%;border-radius:0;border:none;background:var(--tui-elevation-01);box-shadow:0 4rem var(--tui-base-01)}[data-size=fullscreen][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%], [data-size=page][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:3rem calc(50vw - (45rem / 2))}[data-size=fullscreen][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%], [data-size=page][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{margin-bottom:1rem}[data-size=page][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:0}._centered[_nghost-%COMP%]{text-align:center}[_nghost-%COMP%]   tui-root._mobile[data-size][_nghost-%COMP%], tui-root._mobile   [data-size][_nghost-%COMP%]{min-width:100vw;width:100vw;max-width:100vw;border-radius:0;border:none;margin:auto 0 0}[_nghost-%COMP%]   tui-root._mobile[data-size][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%], tui-root._mobile   [data-size][_nghost-%COMP%]   .t-content[_ngcontent-%COMP%]{padding:2rem 1.5rem}[_nghost-%COMP%]   tui-root._mobile[data-size][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%], tui-root._mobile   [data-size][_nghost-%COMP%]   .t-heading[_ngcontent-%COMP%]{margin-bottom:.5rem;font:var(--tui-font-heading-5)}.t-heading[_ngcontent-%COMP%]{margin:0;word-wrap:break-word;font:var(--tui-font-heading-3)}.t-heading[_ngcontent-%COMP%]:empty{display:none}.t-header[_ngcontent-%COMP%]{display:flex;border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden}[data-size=fullscreen][_nghost-%COMP%]   tui-root._mobile[_nghost-%COMP%]   .t-header[_ngcontent-%COMP%], tui-root._mobile   [_nghost-%COMP%]   .t-header[_ngcontent-%COMP%]{flex:1}.t-content[_ngcontent-%COMP%]{border-radius:inherit;padding:2rem;background:var(--tui-base-01)}.t-content[_ngcontent-%COMP%]:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.t-wrapper[_ngcontent-%COMP%]{position:-webkit-sticky;position:sticky;top:0;order:-1}.t-close[_ngcontent-%COMP%]{transition-property:background;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:fixed;top:1.5rem;right:1.5rem;color:var(--tui-base-01);background:rgba(104,104,104,.96)}.t-close[_ngcontent-%COMP%]:hover{background:rgba(159,159,159,.86)}[_nghost-%COMP%]:not([data-size=fullscreen])   .t-close[_ngcontent-%COMP%]{-webkit-animation:tuiFadeIn var(--tui-duration);animation:tuiFadeIn var(--tui-duration)}[_nghost-%COMP%]:not([data-size=fullscreen]).ng-animating   .t-close[_ngcontent-%COMP%]{display:none}tui-root._mobile[_nghost-%COMP%]   .t-close[_ngcontent-%COMP%], tui-root._mobile   [_nghost-%COMP%]   .t-close[_ngcontent-%COMP%]{position:absolute;top:0;right:0;background:0 0;color:var(--tui-base-06)}tui-root._mobile[_nghost-%COMP%]   .t-close[_ngcontent-%COMP%]:hover, tui-root._mobile   [_nghost-%COMP%]   .t-close[_ngcontent-%COMP%]:hover{color:var(--tui-base-07)}.t-buttons[_ngcontent-%COMP%]{margin-top:1.25rem;text-align:right}"], data: { animation: [tuiSlideInTop, tuiFadeIn] }, changeDetection: 0 });
TuiDialogComponent.ctorParameters = () => [
    { type: Number, decorators: [{ type: Inject, args: [TUI_ANIMATIONS_DURATION,] }] },
    { type: Boolean, decorators: [{ type: Inject, args: [TUI_IS_MOBILE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [POLYMORPHEUS_CONTEXT,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_DIALOG_CLOSE_STREAM,] }] },
    { type: Observable, decorators: [{ type: Inject, args: [TUI_CLOSE_WORD,] }] }
];
__decorate([
    HostBinding('attr.data-size')
], TuiDialogComponent.prototype, "size", null);
__decorate([
    HostBinding('class._centered')
], TuiDialogComponent.prototype, "header", null);
__decorate([
    HostBinding('@tuiSlideInTop'),
    HostBinding('@tuiFadeIn')
], TuiDialogComponent.prototype, "slideInTop", null);
TuiDialogComponent = __decorate([ __param(0, Inject(TUI_ANIMATIONS_DURATION)),
    __param(1, Inject(TUI_IS_MOBILE)),
    __param(2, Inject(POLYMORPHEUS_CONTEXT)),
    __param(3, Inject(TUI_DIALOG_CLOSE_STREAM)),
    __param(4, Inject(TUI_CLOSE_WORD))
], TuiDialogComponent);

const DIALOG = new PolymorpheusComponent(TuiDialogComponent);
const DEFAULT_OPTIONS = {
    size: 'm',
    required: false,
    closeable: true,
    dismissible: true,
    label: '',
    header: '',
};
let TuiDialogService = class TuiDialogService extends AbstractTuiDialogService {
    constructor() {
        super(...arguments);
        this.component = DIALOG;
        this.defaultOptions = DEFAULT_OPTIONS;
    }
};
TuiDialogService.ɵfac = /*@__PURE__*/ function () { let ɵTuiDialogService_BaseFactory; return function TuiDialogService_Factory(t) { return (ɵTuiDialogService_BaseFactory || (ɵTuiDialogService_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiDialogService)))(t || TuiDialogService); }; }();
TuiDialogService.ɵprov = ɵɵdefineInjectable({ factory: function TuiDialogService_Factory() { return new TuiDialogService(ɵɵinject(TuiIdService)); }, token: TuiDialogService, providedIn: "root" });

let TuiDialogDirective = class TuiDialogDirective extends AbstractTuiDialogDirective {
};
TuiDialogDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiDialogDirective_BaseFactory; return function TuiDialogDirective_Factory(t) { return (ɵTuiDialogDirective_BaseFactory || (ɵTuiDialogDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiDialogDirective)))(t || TuiDialogDirective); }; }();
TuiDialogDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiDialogDirective, selectors: [["ng-template", "tuiDialog", ""]], inputs: { options: ["tuiDialogOptions", "options"], open: ["tuiDialog", "open"] }, outputs: { openChange: "tuiDialogChange" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: AbstractTuiDialogService,
                useExisting: TuiDialogService
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });

let TuiDialogModule = class TuiDialogModule {
};
TuiDialogModule.ɵfac = function TuiDialogModule_Factory(t) { return new (t || TuiDialogModule)(); };
TuiDialogModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiDialogModule });
TuiDialogModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        {
            provide: TUI_DIALOGS,
            useExisting: TuiDialogService,
            multi: true
        },
    ], imports: [[PolymorpheusModule, TuiButtonModule, CommonModule, TuiPreventDefaultModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogComponent, [{
        type: Component,
        args: [{
                selector: 'tui-dialog',
                template: "<header\n    *ngIf=\"header\"\n    polymorpheus-outlet\n    class=\"t-header\"\n    [content]=\"header\"\n    [context]=\"context\"\n></header>\n<div class=\"t-content\">\n    <h2\n        class=\"t-heading\"\n        [id]=\"context.id\"\n        [textContent]=\"context.label\"\n    ></h2>\n    <section\n        polymorpheus-outlet\n        [context]=\"context\"\n        [content]=\"context.content\"\n    >\n        <ng-template let-text>\n            {{ text }}\n            <div class=\"t-buttons\">\n                <button\n                    tuiButton\n                    size=\"m\"\n                    (click)=\"context.$implicit.complete()\"\n                >\n                    OK\n                </button>\n            </div>\n        </ng-template>\n    </section>\n</div>\n<div\n    *ngIf=\"context.closeable\"\n    class=\"t-wrapper\"\n>\n    <button\n        tuiIconButton\n        tuiPreventDefault=\"mousedown\"\n        automation-id=\"tui-dialog__close\"\n        size=\"s\"\n        appearance=\"\"\n        icon=\"tuiIconCloseLarge\"\n        shape=\"rounded\"\n        class=\"t-close\"\n        [title]=\"closeWord$ | async\"\n        (click)=\"close()\"\n    ></button>\n</div>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TUI_DIALOG_PROVIDERS,
                animations: [tuiSlideInTop, tuiFadeIn],
                styles: [":host{position:relative;display:flex;font:var(--tui-font-text-m);flex-direction:column;box-sizing:border-box;margin:auto;border-radius:1rem;border:40px solid transparent}:host:after{position:absolute;top:0;left:0;width:100%;height:100%;box-shadow:0 1.125rem 1.875rem rgba(0,0,0,.48);content:'';border-radius:inherit;pointer-events:none}:host[data-size='s']{width:30rem}:host[data-size='s'] .t-content{padding:1.5rem}:host[data-size='s'] .t-heading{margin-bottom:.5rem;font:var(--tui-font-heading-5)}:host[data-size='m']{width:42.5rem}:host[data-size='m'] .t-heading{margin-bottom:.75rem;font:var(--tui-font-heading-4)}:host[data-size='l']{width:55rem}:host[data-size='l'] .t-heading{margin-bottom:1rem}:host[data-size=fullscreen],:host[data-size=page]{width:100vw;min-height:100%;border-radius:0;border:none;background:var(--tui-elevation-01);box-shadow:0 4rem var(--tui-base-01)}:host[data-size=fullscreen] .t-content,:host[data-size=page] .t-content{padding:3rem calc(50vw - (45rem / 2))}:host[data-size=fullscreen] .t-heading,:host[data-size=page] .t-heading{margin-bottom:1rem}:host[data-size=page] .t-content{padding:0}:host._centered{text-align:center}:host :host-context(tui-root._mobile)[data-size]{min-width:100vw;width:100vw;max-width:100vw;border-radius:0;border:none;margin:auto 0 0}:host :host-context(tui-root._mobile)[data-size] .t-content{padding:2rem 1.5rem}:host :host-context(tui-root._mobile)[data-size] .t-heading{margin-bottom:.5rem;font:var(--tui-font-heading-5)}.t-heading{margin:0;word-wrap:break-word;font:var(--tui-font-heading-3)}.t-heading:empty{display:none}.t-header{display:flex;border-top-left-radius:inherit;border-top-right-radius:inherit;overflow:hidden}:host[data-size=fullscreen] :host-context(tui-root._mobile) .t-header{flex:1}.t-content{border-radius:inherit;padding:2rem;background:var(--tui-base-01)}.t-content:not(:first-child){border-top-left-radius:0;border-top-right-radius:0}.t-wrapper{position:-webkit-sticky;position:sticky;top:0;order:-1}.t-close{transition-property:background;transition-duration:var(--tui-duration,300ms);transition-timing-function:ease-in-out;position:fixed;top:1.5rem;right:1.5rem;color:var(--tui-base-01);background:rgba(104,104,104,.96)}.t-close:hover{background:rgba(159,159,159,.86)}:host:not([data-size=fullscreen]) .t-close{-webkit-animation:tuiFadeIn var(--tui-duration);animation:tuiFadeIn var(--tui-duration)}:host:not([data-size=fullscreen]).ng-animating .t-close{display:none}:host-context(tui-root._mobile) .t-close{position:absolute;top:0;right:0;background:0 0;color:var(--tui-base-06)}:host-context(tui-root._mobile) .t-close:hover{color:var(--tui-base-07)}.t-buttons{margin-top:1.25rem;text-align:right}"]
            }]
    }], function () { return [{ type: Number, decorators: [{
                type: Inject,
                args: [TUI_ANIMATIONS_DURATION]
            }] }, { type: Boolean, decorators: [{
                type: Inject,
                args: [TUI_IS_MOBILE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [POLYMORPHEUS_CONTEXT]
            }] }, { type: ɵngcc5.Observable, decorators: [{
                type: Inject,
                args: [TUI_DIALOG_CLOSE_STREAM]
            }] }, { type: ɵngcc5.Observable, decorators: [{
                type: Inject,
                args: [TUI_CLOSE_WORD]
            }] }]; }, { size: [{
            type: HostBinding,
            args: ['attr.data-size']
        }], header: [{
            type: HostBinding,
            args: ['class._centered']
        }], slideInTop: [{
            type: HostBinding,
            args: ['@tuiSlideInTop']
        }, {
            type: HostBinding,
            args: ['@tuiFadeIn']
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogDirective, [{
        type: Directive,
        args: [{
                selector: 'ng-template[tuiDialog]',
                providers: [
                    {
                        provide: AbstractTuiDialogService,
                        useExisting: TuiDialogService
                    },
                ],
                inputs: ['options: tuiDialogOptions', 'open: tuiDialog'],
                outputs: ['openChange: tuiDialogChange']
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiDialogModule, [{
        type: NgModule,
        args: [{
                imports: [PolymorpheusModule, TuiButtonModule, CommonModule, TuiPreventDefaultModule],
                declarations: [TuiDialogComponent, TuiDialogDirective],
                exports: [TuiDialogComponent, TuiDialogDirective],
                entryComponents: [TuiDialogComponent],
                providers: [
                    {
                        provide: TUI_DIALOGS,
                        useExisting: TuiDialogService,
                        multi: true
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiDialogModule, { declarations: function () { return [TuiDialogComponent, TuiDialogDirective]; }, imports: function () { return [PolymorpheusModule, TuiButtonModule, CommonModule, TuiPreventDefaultModule]; }, exports: function () { return [TuiDialogComponent, TuiDialogDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_DIALOGS_CLOSE, TUI_DIALOG_CLOSE_STREAM, TUI_DIALOG_PROVIDERS, TuiDialogComponent, TuiDialogDirective, TuiDialogModule, TuiDialogService, dialogCloseStreamFactory };

